/**
 * Rundet Stunden auf den nächsten 0,5er-Schritt AUF (immer aufrunden)
 * Beispiele:
 * 1.2 -> 1.5
 * 1.5 -> 1.5
 * 1.6 -> 2.0
 * 2.1 -> 2.5
 */
export const roundHoursToHalf = (hours) => {
  if (!hours || isNaN(hours)) return 0;
  // Aufrunden auf 0,5er-Schritte: Math.ceil(hours * 2) / 2
  return Math.ceil(hours * 2) / 2;
};

/**
 * Formatiert Stunden mit einer Dezimalstelle
 * Beispiele: 1.5 -> "1,5 h", 2.0 -> "2,0 h"
 */
export const formatHours = (hours) => {
  const rounded = roundHoursToHalf(hours);
  // Deutsche Formatierung mit Komma und einer Dezimalstelle
  return `${rounded.toFixed(1).replace('.', ',')} h`;
};

/** Preserve agreed euro/cent rates independently of the time-rounding rule. */
export const roundHourlyRate = (rate) => {
  const value = Number(rate);
  if (!Number.isFinite(value) || value <= 0) return 0;
  return Math.round((value + Number.EPSILON) * 100) / 100;
};

/**
 * Formatiert Währung (Euro) im deutschen Format
 */
export const formatCurrency = (amount) => {
  return new Intl.NumberFormat('de-DE', {
    style: 'currency',
    currency: 'EUR'
  }).format(amount || 0);
};
